export enum Level {
  intro = 'Intro',
  one = 'Level 1',
  two = 'Level 2',
  three = 'Level 3',
}
